const tone = {
  emerald: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  amber: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  red: "bg-red-500/10 text-red-400 border-red-500/30",
  sky: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  slate: "bg-slate-500/10 text-slate-300 border-slate-500/30",
  orange: "bg-orange-500/10 text-orange-400 border-orange-500/30",
  teal: "bg-teal-500/10 text-teal-300 border-teal-500/30",
};

export const Pill = ({ color = "slate", children, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 font-mono-data text-[11px] uppercase tracking-wider ${tone[color]}`}
  >
    {children}
  </span>
);

const STOCK = {
  in_stock: ["emerald", "In Stock"],
  low_stock: ["amber", "Low Stock"],
  out_of_stock: ["red", "Out of Stock"],
};

export const StockBadge = ({ status, testId }) => {
  const [c, label] = STOCK[status] || STOCK.in_stock;
  return (
    <Pill color={c} testId={testId}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </Pill>
  );
};

const ORDER = { pending: "amber", confirmed: "sky", ready: "teal", completed: "emerald", cancelled: "red" };
export const OrderStatusBadge = ({ status, testId }) => (
  <Pill color={ORDER[status] || "slate"} testId={testId}>
    {status}
  </Pill>
);

export const PaymentBadge = ({ status, testId }) => (
  <Pill color={status === "paid" ? "emerald" : "amber"} testId={testId}>
    {status}
  </Pill>
);

export const MethodBadge = ({ method }) => <Pill color={method === "bitcoin" ? "orange" : "slate"}>{method}</Pill>;

const CLIENT = { pending: "amber", approved: "emerald", disabled: "red" };
export const ClientStatusBadge = ({ status, testId }) => (
  <Pill color={CLIENT[status] || "slate"} testId={testId}>
    {status}
  </Pill>
);

const REQ = { new: "amber", reviewed: "sky", added: "emerald", declined: "red" };
export const RequestStatusBadge = ({ status, testId }) => (
  <Pill color={REQ[status] || "slate"} testId={testId}>
    {status}
  </Pill>
);
